export const allocateOptions = () => {
  const area = document.getElementById("area");
  if (area) {
    return area;
  } else {
    return document.body;
  }
};
